<template>
  <div class="bloco-protocolo container container_com-fundo container_com-margem">
    <h2 class="titulo titulo_grande u-margem-inferior-media">Protocolo</h2>

    <div class="linha-de-dados">
      <span class="item-de-dado">
        <strong>NUP (Processo):</strong>
        <span v-if="!existeNumeroDoProcesso">Ainda não gerado</span>
        <span v-else>{{ numeroDoProcesso }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Operação bancária:</strong>
        <span class="texto">{{ operacaoBancariaFormatada || 'Não informado' }}</span>
      </span>
      <span class="item-de-dado">
        <strong>Origem (assinatura):</strong>
        <span>{{ origemDaAssinatura || 'Não informado' }}</span>
      </span>
      <span class="item-de-dado item-de-dado_situacao-atual">
        <strong>Situação atual:</strong>
        <span>{{ status || 'Não informado' }}</span>
      </span>
    </div>

    <prazo-do-dossie
      v-if="situacaoDoPrazoDoDossie"
      :situacao="situacaoDoPrazoDoDossie"
      @prorrogar="$emit('prorrogar')"
    />
  </div>
</template>

<script>
import { formatarOperacaoBancaria } from '../../../../utils/statusDaSolicitacao';
import PrazoDoDossie from './PrazoDoDossie';

export default {
  name: 'protocolo-da-solicitacao',
  components: { PrazoDoDossie },
  props: {
    existeNumeroDoProcesso: { type: Boolean, default: false },
    numeroDoProcesso: { type: String, default: null },
    operacaoBancaria: { type: String, default: null },
    operacaoBancariaComplementar: { type: String, default: null },
    origemDaAssinatura: { type: String, default: null },
    status: { type: String, default: null },
    situacaoDoPrazoDoDossie: { type: Object, default: null },
  },
  computed: {
    operacaoBancariaFormatada() {
      return formatarOperacaoBancaria(
        this.operacaoBancaria,
        this.operacaoBancariaComplementar,
        ' · '
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProtocoloDaSolicitacao.vue?3cc8f31f